import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Stars, BadgeTier } from "@/components/Bits";
import { Trophy, Crown, Award } from "lucide-react";

export default function Ranking() {
  const [ranking, setRanking] = useState([]);
  useEffect(() => {
    (async () => {
      const { data } = await api.get("/users/ranking");
      setRanking(data.ranking);
    })();
  }, []);

  const podium = ranking.slice(0, 3);
  const rest = ranking.slice(3);

  return (
    <div className="space-y-8 anim-fade-up">
      <div>
        <h1 className="text-3xl font-display font-extrabold">Ranking Nacional</h1>
        <p className="text-zinc-400 text-sm mt-1">Os profissionais mais bem avaliados da plataforma.</p>
      </div>

      {podium.length > 0 && (
        <div className="grid sm:grid-cols-3 gap-3">
          {[
            { u: podium[1], place: 2, icon: Award, color: "border-zinc-500 bg-zinc-800/40" },
            { u: podium[0], place: 1, icon: Crown, color: "border-amber-500 bg-amber-900/30 glow" },
            { u: podium[2], place: 3, icon: Trophy, color: "border-orange-700 bg-orange-950/40" },
          ].filter(x => x.u).map(({u, place, icon: Ic, color}) => (
            <div key={u.user_id} className={`cw-card p-6 border-2 ${color} text-center`}>
              <Ic className={`w-8 h-8 mx-auto mb-2 ${place===1?"text-amber-400":place===2?"text-zinc-300":"text-orange-400"}`} />
              <div className="text-xs text-zinc-500 uppercase tracking-widest mb-1">{place}º lugar</div>
              <div className="font-display font-bold text-lg">{u.name}</div>
              <div className="text-xs text-zinc-400 mb-2">{u.specialty || "Açougueiro"} disponível</div>
              <div className="flex justify-center mb-2"><Stars value={u.rating_avg} /></div>
              <div className="font-mono text-red-500 font-bold">{u.points} pts</div>
              <div className="mt-2 flex justify-center"><BadgeTier badge={u.badge} verified={u.is_verified} /></div>
            </div>
          ))}
        </div>
      )}

      <div className="cw-card divide-y divide-zinc-800">
        {rest.length === 0 && podium.length === 0 && (
          <div className="p-10 text-center text-zinc-400">Ainda não há profissionais no ranking.</div>
        )}
        {rest.map((u, i) => (
          <div key={u.user_id} className="p-4 flex items-center gap-4">
            <div className="w-10 text-center font-mono text-zinc-500 font-bold">#{i + 4}</div>
            <div className="flex-1">
              <div className="font-semibold">{u.name}</div>
              <div className="text-xs text-zinc-500">{u.specialty || "Açougueiro"} disponível · {u.city || "—"}</div>
            </div>
            <Stars value={u.rating_avg} />
            <div className="text-red-500 font-mono font-bold w-20 text-right">{u.points} pts</div>
            <BadgeTier badge={u.badge} verified={u.is_verified} />
          </div>
        ))}
      </div>
    </div>
  );
}
